import React from 'react';

const Map = (props) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 22 22"
		{...props}
	>
		<g>
			<path
				d="m21,4L14.67,1h0s0,0,0,0h-1l-5.83,2.76L2,1h0s-1,0-1,0v17h0l6.33,3h0s1,0,1,0h0s5.83-2.76,5.83-2.76l5.83,2.76h0s0,0,0,0h1V4h0Zm-13.67.63v15.26l-5.33-2.53V2.11l5.33,2.53Zm7.33,12.73V2.1l5.33,2.53v15.26l-5.33-2.53Z"
			/>
		</g>
	</svg>
);

export default Map;
